var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeganTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.58,61.26c-7.49,10-25,18.13-43.73,55.84l-23,53a3.14,3.14,0,0,1-2.8,1.8H91.43a3.33,3.33,0,0,1-2.79-1.8L39,59.54a2.91,2.91,0,0,1,2.8-4.28h6.57a3,3,0,0,1,2.79,1.81l40.92,92h.66a274,274,0,0,1,17.51-37.3C127.73,81.23,149.43,72.77,162.58,61.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.32,123.34a41,41,0,0,1-23.6-7.48c-10-7.23-14.59-18.06-11.88-28.27C102.46,74,112.52,71.5,123.16,68.87c12.55-3.09,28.15-6.93,41.89-29.75a3,3,0,0,1,5.39.51c2.06,5.61,19.19,55.44-12.78,76.48A42.12,42.12,0,0,1,134.32,123.34Zm32.39-75.76C152.5,67.82,136.52,71.76,124.6,74.7c-10.39,2.56-17.26,4.25-20,14.43-2.06,7.74,1.61,16.12,9.58,21.87,8.87,6.39,24.7,10.24,40.14.09C177.65,95.77,170.81,61.72,166.71,47.58Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeganTag);
export default __webpack_public_path__ + "static/media/VeganTag.5625737940fbf63da4ceafd619134e9a.svg";
export { ForwardRef as ReactComponent };